import React from 'react';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { ForecastCardTitleHourDay, LargeCardTitleContainer } from '../../../styles';

export const CardTitleLoadingUI = () => {
    return (
        <LargeCardTitleContainer>
            <ForecastCardTitleHourDay key='card-hour-title'>
                <AnimatedLoadingPlaceholder width={60} height='23px' />
            </ForecastCardTitleHourDay>
            <ForecastCardTitleHourDay isDayTitleText={true} key='card-day-title'>
                <AnimatedLoadingPlaceholder width={60} height='23px' />
            </ForecastCardTitleHourDay>
        </LargeCardTitleContainer>
    );
};
